import { render, staticRenderFns } from "./system-panel.vue?vue&type=template&id=6a9a4346"
import script from "./system-panel.vue?vue&type=script&lang=js"
export * from "./system-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports